import { useEffect, useSyncExternalStore } from "react";

const KEY = "sherlock_dark_mode";

// One value for the whole app: the sidebar's switch, its account menu and
// the command palette all read and set it, and each shows the same state.
let current = null;
const listeners = new Set();

function initial() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored !== null) return stored === "true";
  } catch {
    // Storage blocked: fall back to the system setting.
  }
  return Boolean(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
}

function getDark() {
  if (current === null) current = initial();
  return current;
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function setDark(next) {
  const value = Boolean(typeof next === "function" ? next(getDark()) : next);
  if (value === current) return;
  current = value;
  listeners.forEach((fn) => fn());
}

export function useDarkMode() {
  const dark = useSyncExternalStore(subscribe, getDark, getDark);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    try {
      localStorage.setItem(KEY, String(dark));
    } catch {
      // The choice just isn't remembered.
    }
  }, [dark]);

  return [dark, setDark];
}
